/**
 * 通知配置
 */

export type NotificationType =
    | 'workflow_created'
    | 'step_completed'
    | 'approval_required'
    | 'document_ready'
    | 'deadline_reminder'
    | 'system_alert'

export interface NotificationConfig {
    label: string
    color: string
    icon?: string
    priority: 'low' | 'medium' | 'high' | 'urgent'
}

/**
 * 通知類型配置
 */
export const NOTIFICATION_TYPES: Record<NotificationType, NotificationConfig> = {
    workflow_created: {
        label: '工作流程',
        color: 'blue',
        priority: 'medium',
    },
    step_completed: {
        label: '步驟完成',
        color: 'green',
        priority: 'low',
    },
    approval_required: {
        label: '需要審批',
        color: 'orange',
        priority: 'high',
    },
    document_ready: {
        label: '文件準備',
        color: 'purple',
        priority: 'medium',
    },
    deadline_reminder: {
        label: '截止提醒',
        color: 'red',
        priority: 'urgent',
    },
    system_alert: {
        label: '系統警報',
        color: 'red',
        priority: 'urgent',
    },
}

/**
 * 獲取通知類型標籤
 */
export function getNotificationTypeLabel(type: NotificationType): string {
    return NOTIFICATION_TYPES[type]?.label || '通知'
}

/**
 * 獲取通知類型顏色
 */
export function getNotificationTypeColor(type: NotificationType): string {
    return NOTIFICATION_TYPES[type]?.color || 'gray'
}

/**
 * 獲取通知類型優先級
 */
export function getNotificationTypePriority(type: NotificationType): 'low' | 'medium' | 'high' | 'urgent' {
    return NOTIFICATION_TYPES[type]?.priority || 'medium'
}

/**
 * 根據優先級獲取顏色
 */
export function getPriorityColor(priority: 'low' | 'medium' | 'high' | 'urgent'): string {
    switch (priority) {
        case 'low':
            return 'gray'
        case 'medium':
            return 'blue'
        case 'high':
            return 'orange'
        case 'urgent':
            return 'red'
        default:
            return 'gray'
    }
}

/**
 * 通知設置
 */
export const NOTIFICATION_SETTINGS = {
    // Toast 通知設置
    toast: {
        duration: 5000,
        position: 'top-right' as const,
        isClosable: true,
    },

    // SSE 連接設置
    sse: {
        reconnectDelay: 5000, // 重連延遲（毫秒）
        heartbeatInterval: 30000, // 心跳間隔（毫秒）
    },

    // 通知列表設置
    list: {
        maxItems: 50, // 最多顯示的通知數量
        autoMarkAsReadDelay: 3000, // 自動標記為已讀的延遲（毫秒）
    },
}
